import { useSelector } from "react-redux"
import { selectAuthInitialized, selectCredentials, selectJustLoggedOut, selectLoginCredential, selectPendingEmail } from "../../features/auth/auth-slice"

export const useAuthDataState = () => {

    const pendingEmail = useSelector(selectPendingEmail);
    const justLoggedOut = useSelector(selectJustLoggedOut);
    const loginCredentials = useSelector(selectLoginCredential);
    const loginEmail = loginCredentials.email
    const loginPassword = loginCredentials.password
    const isInitialized = useSelector(selectAuthInitialized);

    const credentials = useSelector(selectCredentials);
    const accessToken = credentials?.accessToken
    const refreshToken = credentials?.refreshToken
    const status = credentials?.status
    const userCredentials = credentials?.user
    const userId = userCredentials?.user_id;
    const userFirstName = userCredentials?.firstname;
    const userMiddleName = userCredentials?.middlename;
    const userLastName = userCredentials?.lastname;
    const userSuffix = userCredentials?.suffix;
    const userEmail = userCredentials?.email;
    const userAgentCode = userCredentials?.agent_code;
    const userPhoneNumber = userCredentials?.phoneNumber;
    const userIsActive = userCredentials?.is_active;
    const userIsMustChangePassword = userCredentials?.mustChangePassword;
    const userRoleId = userCredentials?.role_id;
    const userRoleName = userCredentials?.roleName;
    const userLocationId = userCredentials?.location_id;
    const userLocationName = userCredentials?.locationName;
    const userDepartmentId = userCredentials?.department_id;
    const userDepartmentName = userCredentials?.departmentName;
    const userDepartmentCode = userCredentials?.departmentCode;

    return {
        pendingEmail,
        justLoggedOut,
        loginCredentials,
        loginEmail,
        loginPassword,
        isInitialized,

        credentials,
        accessToken,
        refreshToken,
        status,
        userId,
        userFirstName,
        userMiddleName,
        userLastName,
        userSuffix,
        userEmail,
        userAgentCode,
        userPhoneNumber,
        userIsActive,
        userIsMustChangePassword,
        userRoleId,
        userRoleName,
        userLocationId,
        userLocationName,
        userDepartmentId,
        userDepartmentName,
        userDepartmentCode,
    }
}